/**
 * @param {string[]} gradient1 - array of hex colors
 * @param {string[]} gradient2 - array of hex colors
 * @returns 
 */
export function checkForGradientMatch(gradient1, gradient2) {
  if (!gradient1 || !gradient2) return false;

  if (gradient1.length !== gradient2.length) {
    return false;
  }

  for (let i = 0; i < gradient1.length; i++) {
    if (removeLeadingHash(gradient1[i]) !== removeLeadingHash(gradient2[i])) {
      return false;
    }
  }

  return true;
}

function removeLeadingHash(color) {
  if (color.startsWith("#")) {
    return color.slice(1);
  }
  return color;
}